import { render, staticRenderFns } from "./benchwave.view.vue?vue&type=template&id=1aa205ed&scoped=true&"
import script from "./benchwave.view.vue?vue&type=script&lang=ts&"
export * from "./benchwave.view.vue?vue&type=script&lang=ts&"
import style0 from "./benchwave.view.vue?vue&type=style&index=0&id=1aa205ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa205ed",
  null
  
)

export default component.exports